// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.HelpCenter = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.HelpCenter = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var HelpCenter = _exports.HelpCenter = function HelpCenter(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.99935 1.66699C5.39685 1.66699 1.66602 5.39783 1.66602 10.0003C1.66602 14.6028 5.39685 18.3337 9.99935 18.3337C14.6018 18.3337 18.3327 14.6028 18.3327 10.0003C18.3327 5.39783 14.6018 1.66699 9.99935 1.66699ZM10.016 14.5837C9.55603 14.5837 9.17843 14.2103 9.17843 13.7503C9.17843 13.2903 9.54769 12.917 10.0077 12.917H10.016C10.4769 12.917 10.8494 13.2903 10.8494 13.7503C10.8494 14.2103 10.476 14.5837 10.016 14.5837ZM11.3352 10.4404C10.726 10.8487 10.6126 11.0762 10.5918 11.1362C10.5043 11.397 10.261 11.562 9.99935 11.562C9.93352 11.562 9.86682 11.552 9.80098 11.5295C9.47348 11.4195 9.29773 11.0653 9.4069 10.7378C9.55773 10.2878 9.94859 9.86366 10.6386 9.40116C11.4894 8.83116 11.3802 8.20622 11.3444 8.00122C11.2502 7.45622 10.791 6.99189 10.2518 6.89689C9.84183 6.82189 9.4411 6.92939 9.12777 7.19189C8.81277 7.45606 8.63175 7.84525 8.63175 8.25859C8.63175 8.60359 8.35175 8.88359 8.00675 8.88359C7.66175 8.88359 7.38175 8.60359 7.38175 8.25859C7.38175 7.47442 7.72517 6.73696 8.32434 6.23446C8.91767 5.73779 9.69849 5.53037 10.4693 5.66703C11.5252 5.8537 12.3911 6.72613 12.5752 7.7878C12.7586 8.83947 12.3177 9.78206 11.3352 10.4404Z",
      fill: "#212B36"
    }));
  };
});
